var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('universe-updates-dialog',{directives:[{name:"show",rawName:"v-show",value:(!_vm.flag),expression:"!flag"}],attrs:{"value":_vm.showDialog,"admin":_vm.isAdmin,"locale":_vm.locale},on:{"close":_vm.onClose,"go-to-admin":_vm.onGoToAdmin}})
}
var staticRenderFns = []

export { render, staticRenderFns }